import * as React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledLightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `var(--color-text) !important`,
    boxShadow: `${theme.shadows[1]} !important`,
    borderRadius: `10px !important`,
    padding: `10px !important`,
    fontSize: `13px !important`,
    maxWidth: `500px !important`,
    position: "relative",
    zIndex: 2,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: `${theme.palette.common.white} !important`,
    zIndex: 2,
  },
}));

const LightTooltip = ({ title, children }) => {
  return <StyledLightTooltip title={title}>{children}</StyledLightTooltip>;
};

export default LightTooltip;
